<template>
  <b-card>
    <div class="m-2">
      <b-row>
        <b-col md="2" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              CFU
            </div>
          </div>
        </b-col>
        <b-col md="10" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light">
              : {{cfu}}
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="2" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Division
            </div>
          </div>
        </b-col>
        <b-col md="10" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light">
              : {{division}}
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="2" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Unit
            </div>
          </div>
        </b-col>
        <b-col md="10" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light">
              : {{unit}}
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="2" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Timeline
            </div>
          </div>
        </b-col>
        <b-col md="10" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light">
              : {{quartal}} - {{year}}
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="2" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Sales Plan / Year
            </div>
          </div>
        </b-col>
        <b-col md="10" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light">
              : {{salesYear}}
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Market Requirement / Market Research / CI
            </div>
          </div>
        </b-col>

        <b-col md="12" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light" v-html="ci">
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Proposed Product / Solution
            </div>
          </div>
        </b-col>
        <b-col md="12" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light" v-html="solution">
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              Notes
            </div>
          </div>
        </b-col>
        <b-col md="12" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title txt-dark font-weight-light" v-html="notes">
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" class="mb-1">
          <div class="d-flex justify-content-start align-items-center mb-75">
            <div class="blog-category-title font-weight-bolder txt-dark">
              <b-link target="_blank" :href="attachment">
                <b-button
                  class="txt-xs-2"
                  size="md"
                  variant="primary"
                >
                  <span
                    ><feather-icon size="14" icon="DownloadIcon" />
                    Download File Attachment
                  </span> 
                </b-button>
              </b-link>
            </div>
          </div>
        </b-col>
      </b-row>

    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BModal,
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,
  },
  data() {
    return {
      isLoading:true,
      cfu:null,
      division:null,
      unit:null,
      quartal:null,
      year:null,
      ci:'',
      solution:'',
      salesYear:'',
      notes:'',
      attachment:null
    }
  },

  watch: {
    
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.isBusy = true

      this.$http
        .get('/request_prod/detail/'+this.$route.params.key, {
        })
        .then(({ data }) => {
          this.cfu = data.cfu.name
          this.division = data.division.division
          this.unit = data.unit
          this.quartal = data.quartal
          this.year = data.year
          this.ci = data.ci
          this.solution = data.solution
          this.salesYear = data.sales_year
          this.notes = data.notes
          this.attachment = data.file_url
        })
        .finally(() => {
          this.isBusy = false
        })
    }
  },
}
</script>
